import { boolean } from 'zod';

import { PromptAtPumpSchema } from '@occc-app/routes/CampaignComponents/PromptAtPump/validation';

import { CustomDataSchema, OfferNameAndDescriptionSchema } from '@occc/validation';
import { FulfillmentChannelConstraintSchema } from '@occc/feat-constraints/schemas';
import { fulfillmentWindowZodSchema } from '@occc/feat-constraints';

export const BaseConfigurationSchema = OfferNameAndDescriptionSchema.extend({
  fulfillmentWindow: fulfillmentWindowZodSchema,
  fulfillmentChannelConstraint: FulfillmentChannelConstraintSchema,
  promptAtPump: PromptAtPumpSchema,
  customData: CustomDataSchema,
  stackable: boolean().optional(),
});
